import { useNavigation } from '@react-navigation/core'
import { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { paths } from '../../../api/pathsApi'
import { AuthContext } from '../../../context/Auth/AuthContext'
import { InitialDataFreshWater } from '../../../context/FreshWater/types'
import { InitialDataResponse } from '../../../context/SeaWater/types'
import { useGetInitialDataByArea } from '../../../hooks/useGetInitialDataByArea'
import { StackNavigationProp } from '@react-navigation/stack'
import { ControlServiceResponse } from '../../../context/SeaWater/ControlServices/types'
import { useContextApp } from '../../../hooks/useContextApp'
import { AreaSelected } from '../../../context/Auth/AuthReducer'
import { RootParams } from '../../../navigator/types'
import { InitialData } from '../../../context/Necropsy/types'
import { FuelResponse } from '../../../context/Logistics/fuel/types'
import { usePost } from '../../../hooks/usePost'
import { Platform } from 'react-native'
const SEA_WATER = 'seaWater'

interface NavigationParams extends StackNavigationProp<RootParams, 'AreaSelectorScreen'> {}

export const GetLogisticInitialParameters = ({
  onSuccess,
}: {
  onSuccess: (data: FuelResponse) => void
}) => {
  return usePost<{ id_user: number }, FuelResponse>({
    url: paths().LOGISTIC.INITIAL_DATA,
    onSuccess: onSuccess,
  })
}

export const useAreaSelector = () => {
  const { handleAreaSelected, handleLogOut, user, getTokenUrl, changeURLToken, tokenType } =
    useContext(AuthContext)

  const {
    freshWaterContext,
    seaWaterContext,
    controlServicesContext,
    necropsyContext,
    fuelContext,
  } = useContextApp()
  const navigation = useNavigation<NavigationParams>()
  const { t } = useTranslation()

  const freshWaterData = useGetInitialDataByArea<InitialDataFreshWater>({
    url: paths().SYNC.INITIAL_FRESH,
    enabled: false,
    onSuccess(data) {
      handleAreaSelected('sweetWater')
      navigation.navigate('HomeScreen')
      freshWaterContext.handleInittialData(data)
    },
  })
  const seaWaterData = useGetInitialDataByArea<InitialDataResponse>({
    url: paths().SYNC.INITIAL_SEA,
    enabled: false,
    onSuccess(data) {
      handleAreaSelected('seaWater')
      seaWaterContext.handleInittialData(data)
    },
  })
  const controlServiceData = useGetInitialDataByArea<ControlServiceResponse>({
    url: paths().CONTROL_SERVICES.INITIAL_DATA,
    enabled: false,
    onSuccess(data) {
      if (getTokenUrl && Platform.OS === 'web' && tokenType === 'url') {
        changeURLToken(false)
        navigation.navigate('ControlServicesStack', { screen: 'ControlServices' })
      } else {
        navigation.navigate('HomeScreen')
      }
      controlServicesContext.handleInitialDataCS(data)
    },
  })

  const necropsyData = useGetInitialDataByArea<InitialData[]>({
    url: paths().HEALT.INITIAL_DATA,
    enabled: false,
    onSuccess(data) {
      handleAreaSelected('health')
      necropsyContext.handleInitialData(data)
      navigation.navigate('HomeScreen')
    },
  })

  const fuelData = GetLogisticInitialParameters({
    onSuccess: (data) => {
      handleAreaSelected('logistic')
      fuelContext.handleInitialData(data)
      navigation.navigate('HomeScreen')
    },
  })

  const handelSelectedArea = async (areaType: AreaSelected) => {
    const dataInitialMap = {
      seaWater: seaWaterData,
      sweetWater: freshWaterData,
      health: necropsyData,
      logistic: {
        getInitialData() {
          fuelData.handleSendData({ ['id_user']: user.userId! })
        },
      },
    }

    const dataInitial = areaType && dataInitialMap[areaType]
    if (dataInitial) {
      await dataInitial.getInitialData()
      if (areaType === SEA_WATER) {
        await controlServiceData.getInitialData()
      }
    }
  }

  useEffect(() => {
    if (user.assignedAreas === 1) {
      handelSelectedArea(user.areaSelected!)
    }
  }, [])

  return {
    handleLogOut,
    handelSelectedArea,
    freshWaterData,
    seaWaterData,
    controlServiceData,
    t,
    user,
    necropsyData,
    fuelData,
  }
}
